import axios from 'src/axios';
import { APICONSTANTS } from 'src/components/Constants';

// Re-exported so the bulk edit reads responses the same way as the legend drop
// and the sidebar sections. See recordRouteResponse.js.
export { savedListFrom, mergeSavedRecords } from '../recordRouteResponse';

function getMemberApiId(member) {
  return member.proBandId ?? member.familyMemberId;
}

function getUserId(user) {
  return user?.user_id || user?._id;
}

// Our own refusal, worded in English and translated where it is shown; the
// mark tells it apart from a server's or the network's message, which never is.
const memberNotSaved = (message) =>
  Object.assign(new Error(message), { ownMessage: true });

export async function saveDiseases(user, member, newDiseases) {
  if (!newDiseases.length) return null;
  const id = getMemberApiId(member);
  const user_id = getUserId(user);
  if (!id || !user_id) throw memberNotSaved('Member not yet saved to server');

  return axios.post(APICONSTANTS.diagnoses, {
    familyId: user.familyId,
    familyMemberId: id,
    user_id,
    isProband: !!member.proBandId,
    diagnoses: newDiseases
  });
}

export async function deleteDisease(user, member, diagnoseId) {
  const id = getMemberApiId(member);
  const user_id = getUserId(user);
  if (!id || !user_id) throw memberNotSaved('Member not yet saved');

  return axios.delete(
    APICONSTANTS.deleteDiagnosesById
      .replace(':user_id', user_id)
      .replace(':familyMemberId', id),
    { data: { diagnoseId, isProband: !!member.proBandId } }
  );
}

export async function savePhenotypes(user, member, newPhenotypes) {
  if (!newPhenotypes.length) return null;
  const id = getMemberApiId(member);
  const user_id = getUserId(user);
  if (!id || !user_id) throw memberNotSaved('Member not yet saved to server');

  return axios.post(APICONSTANTS.phenotypes, {
    familyId: user.familyId,
    familyMemberId: id,
    user_id,
    isProband: !!member.proBandId,
    phenotypes: newPhenotypes
  });
}

export async function deletePhenotype(user, member, phenotypeId) {
  const id = getMemberApiId(member);
  const user_id = getUserId(user);
  if (!id || !user_id) throw memberNotSaved('Member not yet saved');

  return axios.delete(
    APICONSTANTS.deletePhenotypeById
      .replace(':user_id', user_id)
      .replace(':familyMemberId', id),
    { data: { phenotypeId, isProband: !!member.proBandId } }
  );
}

export async function saveGenotypes(user, member, newGenotypes) {
  if (!newGenotypes.length) return null;
  const id = getMemberApiId(member);
  const user_id = getUserId(user);
  if (!id || !user_id) throw memberNotSaved('Member not yet saved to server');

  return axios.post(APICONSTANTS.genotypes, {
    familyId: user.familyId,
    familyMemberId: id,
    user_id,
    isProband: !!member.proBandId,
    genotypes: newGenotypes
  });
}

export async function deleteGenotype(user, member, genotypeId) {
  const id = getMemberApiId(member);
  const user_id = getUserId(user);
  if (!id || !user_id) throw memberNotSaved('Member not yet saved');

  return axios.delete(
    APICONSTANTS.deleteGenotypeById
      .replace(':user_id', user_id)
      .replace(':familyMemberId', id),
    { data: { genotypeId, isProband: !!member.proBandId } }
  );
}
